import React from 'react';
import { TextField as MuiTextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';

type PasswordFieldProps = TextFieldProps & {
  handleChange: (value: string) => void;
};

function PasswordField(props: PasswordFieldProps) {
  const { handleChange, ...rest } = props;

  return (
    <MuiTextField
      label='Password'
      type='password'
      autoComplete='current-password'
      variant='standard'
      onChange={(event) => handleChange(event.target.value)}
      {...rest}
    />
  );
}

export type { PasswordFieldProps };

export default PasswordField;
